import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { reverseSegmentMap } from '../routes/routeConfig';
import hu from './locales/hu.json';
import en from './locales/en.json';

function detectInitialLanguage(): string {
  const segments = window.location.pathname.split('/').filter(Boolean);
  if (segments.length > 0) {
    const match = reverseSegmentMap[segments[0]];
    if (match) return match.lang;
  }
  return 'hu';
}

i18n.use(initReactI18next).init({
  resources: {
    hu: { translation: hu },
    en: { translation: en },
  },
  lng: detectInitialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
